import FormBlock from "@common/controls/Form/Block/component";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import { type Affiliate } from "../types";

type Props = {
  onClick: (id: string) => void;
  options: Affiliate.ReportOptionItem[];
  style?: React.CSSProperties;
};
export const AnalyticsWidget = (props: Props) => {
  const i18n = useI18n();

  return (
    <FormBlock style={props.style} className="affiliate_analytics_block" isNarrow title={i18n.analytics}>
      <ul className="items">
        {props.options.map((x) => (
          <li key={x.value} className="item" onClick={() => props.onClick(x.value)}>
            <span>{x.label}</span>
          </li>
        ))}
      </ul>
    </FormBlock>
  );
};
